import Header from 'components/header/Header';
import Banner from 'components/banner/Banner';
import TheProblem from 'components/problem/TheProblem';
import TheSolution from 'components/solution/TheSolution';
import TheBenefits from 'components/benefits/TheBenefits';
import AboutUs from 'components/about_us/AboutUs';
import TheTeam from 'components/team/TheTeam';
import ViaForm from 'components/form/ViaForm';
import Fruits from 'components/fruits/Fruits';

function App() {
  return (
    <div className='app'>
      <div className="head">
        <Header />
      </div>
      <div className="sections">
        <Banner />
        <TheProblem />
        <TheSolution />
        <TheBenefits />
        <AboutUs />
        <TheTeam />
        <ViaForm />
        <Fruits />
      </div>
    </div>
  );
}

export default App;
